export enum BLOG_CATEGORY {
  ALL = 'all',
  TECH = 'tech',
  PNC = 'pnc',
}
